<stages-card #card [contentCollapsible]="contentCollapsible">
<!--	[toolbarId]="toolbarId" [toolbarItems]="toolbarItems" [menuId]="menuId" [menuItems]="menuItems" [menuNoCollapse]="menuNoCollapse">-->
	<h5 [translate]="title"></h5>
	<ng-container stagesSlot="content" />
	@if (sequenceOptions && card.expanded) {
		<stages-add-sequence [sequences]="sequenceOptions" />
	}
</stages-card>
